<template>
  <div class="main">
    <div class="conts" data-sensors-click name="consulting2-click">
      <img
        src="https://derucci-app.obs.cn-south-1.myhuaweicloud.com/web/activity/321/p01.jpg"
        alt=""
      />
      <img
        class="btn1"
        data-sensors-click
        name="consulting-btn1-click"
        @click="handleChat(1)"
        src="https://derucci-app.obs.cn-south-1.myhuaweicloud.com/web/activity/321/btn1.png"
        alt=""
      />
    </div>
    <div class="conts" data-sensors-click name="consulting3-click">
      <img
        src="https://derucci-app.obs.cn-south-1.myhuaweicloud.com/web/activity/321/p02.jpg"
        alt=""
      />
    </div>
    <div class="banner banner1">
      <van-swipe :autoplay="3000" :loop="true">
        <van-swipe-item v-for="(image, index) in banner" :key="index">
          <img
            :src="image"
            class="banners"
            data-sensors-click
            :name="`consulting-banner${index}-click`"
          />
        </van-swipe-item>
      </van-swipe>
    </div>
    <div class="banner banner2">
      <van-swipe :autoplay="3000" :loop="true">
        <van-swipe-item v-for="(image, index) in aBanner" :key="index">
          <img
            :src="image"
            class="banners"
            data-sensors-click
            :name="`consulting-banner${index}-click`"
          />
        </van-swipe-item>
      </van-swipe>
    </div>
    <div class="conts" data-sensors-click name="consulting4-click">
      <img
        src="https://derucci-app.obs.cn-south-1.myhuaweicloud.com/web/activity/321/p05.jpg"
        alt=""
      />
      <img
        class="btn2"
        data-sensors-click
        name="consulting-btn2-click"
        @click="handleChat(2)"
        src="https://derucci-app.obs.cn-south-1.myhuaweicloud.com/web/activity/321/btn1.png"
        alt=""
      />
    </div>
  </div>
</template>
<script>
export default {
  name: "sleep2",
  data() {
    return {
      banner: [
        "https://derucci-app.obs.cn-south-1.myhuaweicloud.com/web/activity/321/b1-1.png",
        "https://derucci-app.obs.cn-south-1.myhuaweicloud.com/web/activity/321/b1-2.png",
        "https://derucci-app.obs.cn-south-1.myhuaweicloud.com/web/activity/321/b1-3.png",
      ],
      aBanner: [
        "https://derucci-app.obs.cn-south-1.myhuaweicloud.com/web/activity/321/b2-1.png",
        "https://derucci-app.obs.cn-south-1.myhuaweicloud.com/web/activity/321/b2-2.png",
      ],
    };
  },
  mounted() {
    document.title = "慕思321世界睡眠日";
    const {
      adchannel = "",
      adproject = "",
      adtitle = "",
      adspare = "",
      ad_id = "",
    } = this.$route.query;
    this.$sensors.registerPage({
      platform_type: "H5",
      app_name: "广告投放",
      ad_id,
      adchannel,
      adproject,
      adtitle,
      adspare,
    });

    this.$sensors.use("SensorsChannel");
    this.$sensors.use("PageLoad");
    this.$sensors.use("PageLeave");
    this.$sensors.quick("autoTrack"); //用于采集 $pageview 事件。
  },
  methods: {
    handleChat(num) {
      window.open(
        "https://ai.youju360.com/webAi/index.html?token=2de5ca29bc03ed557d4aeaccd2cc385a"
      );
      this.$sensors.track("SubCustomer", { message: "点击客服" + num });
    },
    backtop() {
      const form = document.querySelector("#formBox");
      var timer = setInterval(function () {
        let osTop =
          document.documentElement.scrollTop || document.body.scrollTop;
        let ispeed = Math.floor(-osTop / 5);
        document.documentElement.scrollTop = document.body.scrollTop =
          osTop + ispeed;
        this.isTop = true;
        if (osTop <= form.offsetTop) {
          clearInterval(timer);
        }
      }, 30);
    },
  },
};
</script>
<style scoped lang="scss">
::v-deep {
  .van-swipe-item {
    text-align: center;
  }

  .van-swipe__indicators {
    display: none;
  }
}

.main {
  background-color: #49c0ac;

  .conts {
    position: relative;
    .btn1 {
      position: absolute;
      top: 560px;
      left: 50%;
      width: 261px;
      transform: translateX(-50%);
    }
    .btn2 {
      position: absolute;
      top: 20px;
      left: 50%;
      width: 261px;
      transform: translateX(-50%);
    }
    img {
      display: block;
      width: 100%;
    }
  }
  .banner1 {
    padding: 0 60px;
    padding-top: 10px;
    padding-bottom: 100px;
    background: url(https://derucci-app.obs.cn-south-1.myhuaweicloud.com/web/activity/321/p03.jpg)
      no-repeat;
    background-size: 100% auto;
    .banners {
      height: 200px;
      width: 100%;
    }
  }
  .banner2 {
    padding: 0 60px;
    // padding-top: 20px;
    // padding-bottom: 10px;
    background: url(https://derucci-app.obs.cn-south-1.myhuaweicloud.com/web/activity/321/p04.jpg)
      no-repeat;
    background-size: 100% auto;
    .banners {
      // height: 300px;
      width: 100%;
    }
  }
}
</style>
